import SecurityComponent from './Security.vue'
export default SecurityComponent
